<template>
    <div class="app-tab-bar">
        <!-- 下方导航 -->
        <van-tabbar
        v-model="active"
        active-color="#8FC31F"
        inactive-color="#000"
        @change="onChange"
        shape="round"
        route
        >
            <van-tabbar-item icon="home-o" to="/home">首页</van-tabbar-item>
            <!-- <van-tabbar-item icon="label-o" to="/topic">专题</van-tabbar-item> -->
            <van-tabbar-item icon="apps-o" to="/category" v-if="showCategoryTab">分类</van-tabbar-item>
            <van-tabbar-item icon="shopping-cart-o" to="/cart" :badge="badge">购物车</van-tabbar-item>
            <van-tabbar-item icon="user-o" to="/user">我的</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
import { GetCartCountData } from "@/https/http";
import store from '@/store/index.js';
export default {
    name: "app-tab-bar",
    data () {
        return {
            active: 0,
            badge: '',
            timer: null
        }
    },
    computed: {
        // 根据活动ID判断是否显示分类标签
        showCategoryTab() {
            const activityId = store.getters.getActivityId;
            return activityId !== 15;
        }
    },
    created() {
        this.getCartCount();
    },
    methods: {
        onChange(m) {
            this.active = m
        },
        getCartCount() {
            // 检查是否已登录
            const token = localStorage.getItem('token');
            if (!token) {
                this.badge = '';
                return;
            }
            
            if (this.timer) {
                clearTimeout(this.timer);
            }
            
            this.timer = setTimeout(() => {
                GetCartCountData().then((res) => {
                    console.log('购物车数量:', res);
                    this.badge = res.data;
                }).catch(err => {
                    // 处理错误时清空角标
                    this.badge = '';
                    console.error('获取购物车数量失败:', err);
                });
            }, 300);
        }
    },
    watch: {
        $route(to, from) {
            // 只在特定路由变化时更新购物车数量
            if (to.path === '/cart' || from.path === '/cart' || 
                to.path === '/home' || to.path === '/user') {
                this.getCartCount();
            }
        }
    },
    beforeDestroy() {
        // 组件销毁前清除定时器
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }
};
</script>

<style></style>
